import React from 'react'
import Bupot26Form from './../PPh/SPT23In/Bupot26In/Bupot26In.form.view'

export default class Bupot26HistoryForm extends Bupot26Form {
    
}